const state = {
  availableTagsMode: null,
  configAlertMode: null,
}

const getters = {
  availableTagsMode: (state) => state.availableTagsMode,
  configAlertMode: (state) => state.configAlertMode,
}

const actions = {}

const mutations = {
  SET_AVAILABLE_TAGS_MODE: (state, mode) => {
    state.configAlertMode = null
    state.availableTagsMode = mode
  },
  SET_CONFIG_ALERT_MODE: (state, mode) => {
    state.availableTagsMode = null
    state.configAlertMode = mode
  },
  RESET_STATE: (state) => {
    state.availableTagsMode = null
    state.configAlertMode = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
